var map = {
	"./position1.png": 5626,
	"./position10.png": 3520,
	"./position11.png": 1641,
	"./position12.png": 674,
	"./position13.png": 1851,
	"./position14.png": 1636,
	"./position15.png": 5533,
	"./position16.png": 1558,
	"./position17.png": 4847,
	"./position18.png": 5000,
	"./position19.png": 8865,
	"./position2.png": 6737,
	"./position20.png": 5381,
	"./position21.png": 3116,
	"./position22.png": 7047,
	"./position23.png": 7550,
	"./position24.png": 6033,
	"./position25.png": 4904,
	"./position26.png": 515,
	"./position27.png": 8602,
	"./position28.png": 5725,
	"./position29.png": 4596,
	"./position3.png": 6520,
	"./position30.png": 3370,
	"./position31.png": 4595,
	"./position32.png": 9320,
	"./position33.png": 3537,
	"./position4.png": 6135,
	"./position5.png": 3646,
	"./position6.png": 5749,
	"./position7.png": 3484,
	"./position8.png": 3371,
	"./position9.png": 8546
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6786;